export type UserRole = 'admin' | 'content_creator' | 'user' | 'provider' | 'family' | 'patient';

export interface RolePermission {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
}

export const DEFAULT_PERMISSIONS: Record<UserRole, RolePermission[]> = {
  admin: [
    {
      id: 'manage_all',
      name: 'Manage All',
      description: 'Full system access',
      enabled: true
    },
    {
      id: 'blog_management',
      name: 'Blog Management',
      description: 'Create and manage blog posts',
      enabled: true
    }
  ],
  content_creator: [
    {
      id: 'blog_management',
      name: 'Blog Management',
      description: 'Create and manage blog posts',
      enabled: true
    }
  ],
  user: [],
  provider: [],
  family: [],
  patient: []
};